<div class="implement-card-wrapper">
  <ion-header>
    <ion-toolbar color="light">
      <ion-title>Implement List</ion-title>
    </ion-toolbar>
  </ion-header>
  <div id="implement-list-card">
    <ion-list *ngFor="let implement of implementList" [style.background-color]="implement.color">
        <ion-row class="ion-align-items-start">
          <ion-col size="auto">
            <ion-icon style="color: #000;" name="{{implement.icon}}"></ion-icon>
          </ion-col>
          <ion-col style="color: #000;">
            <ion-row class="ion-text-start ion-text-wrap" (click)="onSelectImplement(implement.id)">{{implement.name}}</ion-row>
            <ion-row class="ion-text-start ion-text-wrap" *ngIf="implement.name">{{implement.make}} {{implement.model}}</ion-row>
          </ion-col>
        </ion-row>
    </ion-list>
    <ion-footer></ion-footer>
  </div>
</div>
